<template>
    <v-layout row wrap>
        <v-flex xs10 offset-xs1 lg8 offset-lg2>
            <v-form ref="form" @submit.prevent="submit">
                <v-card class="pa-3" v-if="!loading">
                    <v-card-text>

                        <div class="subheading">{{ $t('label.basicInfo') }}</div>
                        <v-layout row>
                            <v-flex xs3 lg2>
                                <label class="form-label">{{ $t('label.acronym') }}</label>
                            </v-flex>
                            <v-flex xs7 lg5>
                                <v-text-field :disabled="disabled" v-model="form.acronym" :maxlength="constants.LENGTH_SYSTEM_ACRONYM"></v-text-field>
                            </v-flex>
                        </v-layout>
                        <v-layout row>
                            <v-flex xs3 lg2>
                                <label class="form-label">{{ $t('label.name') }}</label>
                            </v-flex>
                            <v-flex xs7 lg5>
                                <v-text-field :disabled="disabled" v-model="form.name" :rules="validation.text"></v-text-field>
                            </v-flex>
                        </v-layout>
                        <v-layout row>
                            <v-flex xs3 lg2>
                                <label class="form-label">{{ $t('label.email') }}</label>
                            </v-flex>
                            <v-flex xs7 lg5>
                                <v-text-field :disabled="disabled" v-model="form.email" :rules="validation.email"></v-text-field>
                            </v-flex>
                        </v-layout>
                        <v-layout row>
                            <v-flex xs3 lg2>
                                <label class="form-label">{{ $t('label.active') }}?</label>
                            </v-flex>
                            <v-flex xs9 lg10>
                                <v-checkbox :disabled="disabled" v-model="form.isActive" color="primary"></v-checkbox>
                            </v-flex>
                        </v-layout>
                        <v-layout row>
                            <v-flex xs2 lg2>
                                <label class="form-label">{{ $t('label.controlAccess') }}?</label>
                            </v-flex>
                            <v-flex xs1 lg1>
                                <v-checkbox :disabled="disabled" v-model="form.controlAccess" color="primary"></v-checkbox>
                            </v-flex>
                            <v-flex xs2 lg2>
                                <label class="form-label">Controla Contrato?</label>
                            </v-flex>
                            <v-flex xs1 lg1>
                                <v-checkbox :disabled="disabled" v-model="form.controlContract" color="primary"></v-checkbox>
                            </v-flex>
                            <v-flex xs2 lg2>
                                <label class="form-label">Controla Avaliação?</label>
                            </v-flex>
                            <v-flex xs1 lg1>
                                <v-checkbox :disabled="disabled" v-model="form.controlEvaluation" color="primary" @change="onChange"></v-checkbox>
                            </v-flex>
                            <v-flex xs2 lg2 v-if="form.controlEvaluation">
                                <label class="form-label">{{$t('label.evaluationStartDate')}}</label>
                            </v-flex>
                            <v-flex xs2 lg2 v-if="form.controlEvaluation">
                                <app-menu-date-picker
                                      :model.sync="form.evaluationStartDate"
                                      :disabled="disabled"
                                      :label="$t('label.evaluationStartDate')"
                                ></app-menu-date-picker>
                            </v-flex>
                        </v-layout>
                    </v-card-text>

                    <v-card-actions v-if="!disabled">
                        <v-btn :loading="saving" @click="save" color="primary">{{ $t('label.save') }}</v-btn>
                        <v-spacer></v-spacer>
                    </v-card-actions>
                </v-card>
                <v-card v-else>
                    <app-card-loader></app-card-loader>
                </v-card>
            </v-form>
        </v-flex>
    </v-layout>
</template>

<script>
import constants from '@/helpers/constants';
import utilities from '@/helpers/utilities';
import validation from '@/helpers/validation';
import Office from '@/helpers/entities/Office';
import MenuDatePicker from "@/components/shared/MenuDatePicker";

import CardLoader from '@/components/shared/CardLoader';

export default {
    data() {
        return {
            constants,
            validation,
            valid: true,
            saving: false,
            loading: true,

            form: Office.build(),
        };
    },
    computed: {
        isAdmin() {
            const ok = this.$store.getters.isAdmin;
            return ok;
        },
        disabled() {
            return !this.$store.getters.isAdmin;
        },
    },

    components: {
        appCardLoader: CardLoader,
        appMenuDatePicker: MenuDatePicker,
    },

    watch: {
        $route: 'fetch',
    },

    created() {
        this.fetch();
    },

    methods: {
        onChange() {
            if (!this.form.controlEvaluation) {
                this.form.evaluationStartDate = '';
            }
        },
        async fetch() {
            this.loading = true;

            const id = this.$route.params.id;
            if (!utilities.isEmptyOrZero(id)) {
                await this.$store.dispatch('fetchOffice', this.$route.params.id);
                this.form = Office.toForm(this.$store.getters.office);
            }

            this.loading = false;
        },

        async save() {
            if (!this.$refs.form.validate()) return;

            this.saving = true;
            await this.$store.dispatch('saveOrUpdateOffice', Office.toPayload(this.form));
            this.$router.push({ name: 'officeIndex' });
        },
    },
};
</script>




// WEBPACK FOOTER //
// src/components/offices/Edit.vue